export default __webpack_public_path__ + "static/media/DavidVideoBG.3db66683.png";